import { createSlice } from '@reduxjs/toolkit';

const initialState: any = {
  learningMaterialList: [],
  learningMaterialCreation: {},
  loading: false,
  success: false,
  contentCreatorList: [],
};

const gradeSlice = createSlice({
  name: 'learningMaterials',
  initialState,
  reducers: {
    setLoading(state, action) {
      state.loading = action.payload;
    },
    setSuccess(state, action) {
      state.success = action.payload;
    },
    setLearningMaterialList(state, action) {
      state.learningMaterialList = action.payload;
    },
    setLearningMaterialCreation(state, action) {
      state.learningMaterialCreation = action.payload;
    },
    patchLearningMaterialCreation(state, action) {
      state.learningMaterialCreation = {
        ...state.learningMaterialCreation,
        ...action.payload,
      };
    },
    clearLearningMaterialData(state) {
      state.learningMaterialList = [];
      state.learningMaterialCreation = {};
    },
    setContentCreatorList(state, action) {
      state.contentCreatorList = action.payload;
    },
  },
});

export const {
  setLoading,
  setSuccess,
  setLearningMaterialList,
  setLearningMaterialCreation,
  clearLearningMaterialData,
  patchLearningMaterialCreation,
  setContentCreatorList,
} = gradeSlice.actions;

export default gradeSlice.reducer;
